import { render, staticRenderFns } from "./uf_base_year.vue?vue&type=template&id=6814a8f1&scoped=true"
import script from "./uf_base_year.vue?vue&type=script&lang=js"
export * from "./uf_base_year.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6814a8f1",
  null
  
)

export default component.exports